@if (pageData()) {
  @if (isStickyVisible) {
    <app-section-template [isSticky]="true" [hasPadding]="false">
      <app-select-category
        [noPadding]="true">
      </app-select-category>
    </app-section-template>
  }

  <app-section-template [has32Padding]="true">
    <div class="wrapper latest-news-section">
      <div class="main-section">
        <app-select-category #selectCategory></app-select-category>
        <app-latest-news-section [data]="pageData()?.latestNews"></app-latest-news-section>
      </div>
      <div class="right-section">
        @if (pageData()?.spotlights && pageData()?.spotlights.length) {
          <app-carousel [images]="pageData().spotlights"></app-carousel>
        }
        <div class="latest-meetings">
          <app-latest-meetings-section [meetings]="pageData().latestMeetings"></app-latest-meetings-section>
        </div>
      </div>
    </div>
  </app-section-template>

  <app-important-dates-section [data]="pageData().importantDates"></app-important-dates-section>

  <app-latest-publications-section [data]="pageData().latestPublications"></app-latest-publications-section>

  <app-popular-section [data]="pageData().popular"></app-popular-section>
}
